import { render, staticRenderFns } from "./GDPRAudit.vue?vue&type=template&id=cff6635a&"
import script from "./GDPRAudit.vue?vue&type=script&lang=js&"
export * from "./GDPRAudit.vue?vue&type=script&lang=js&"
import style0 from "./GDPRAudit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports